import React, { Component } from 'react'

import classes from './KpiType.scss'
import {
  checkValidity,
  updateFormOptions,
  updateFilterOptions,
  getPageStatus,
  updateObject,
  extractFilterOptions,
  validateForm
} from '../../../../helpers/utils'

import { connect } from 'react-redux'
import * as actions from '../../../../store/actions/index'

import Aux from '../../../../hoc/Auxiliary/Auxiliary'
// import Button from '../../../../components/UI/Button/Button'
import Alert from '../../../../components/Alert/Alert'
import Card from '../../../../components/UI/Card/Card'
import CardHeader from '../../../../components/UI/Card/Header/Header'
import CardBody from '../../../../components/UI/Card/Body/Body'
import DataTable from '../../../../components/DataTable/DataTable'
import FilterBar from '../../../../components/FilterBar/FilterBar'
import Form from '../../../../components/PageContent/SetupData/KpiType/Form/Form'
import Modal from '../../../../components/UI/Modal/Modal'
import ConfirmationModal from '../../../../components/ConfirmationModal/ConfirmationModal'
import FilterModal from '../../../../components/FilterModal/FilterModal'
import Spinner from '../../../../components/UI/Spinner/Spinner'
import { Checkbox } from '@material-ui/core'
import { Edit, Delete, Add } from '@material-ui/icons'
import withTranslate from 'react-redux-multilingual/lib/withTranslate'
import Footer from '../../../../components/UI/Modal/Footer/Footer'
class KpiType extends Component {
  state = {
    modalOpen: false,
    confirmationModalOpen: false,
    filterModalOpen: false,
    action: 'add',
    addAno: false,
    actionRecordId: null,
    formValid: false,
    searchText: '',
    withSeq: true,
    filter: {},
    inputGroups: {
      kpi_type_name: {
        label: this.props.translate('kpiTypeName'),
        elementType: 'input',
        elementConfig: {
          placeholder: this.props.translate('kpiTypeName')
        },
        value: '',
        validation: {
          required: true
        },
        valid: false,
        touched: false,
        error: null
      },
      company_id: {
        label: this.props.translate('company'),
        elementType: 'newselect',
        elementConfig: {
          type: 'text',
          placeholder: this.props.translate('select') + this.props.translate('company'),
          options: [
            { value: '', label: this.props.translate('select') + this.props.translate('company') }
          ]
        },
        value: {},
        validation: {
          required: true
        },
        valid: false,
        touched: false,
        error: null
      },
      is_active: {
        label: this.props.translate('active'),
        elementType: 'checkbox',
        value: true,
        validation: false,
        valid: true
      }
    },
    filterControls: {
      company_id: {
        label: this.props.translate('company'),
        value: '',
        configs: {
          placeholder: this.props.translate('select') + this.props.translate('company'),
          options: [
            { value: '', label: this.props.translate('select') + this.props.translate('company') }
          ]
        }
      },
      kpi_type_id: {
        label: this.props.translate('kpiTypeName'),
        value: '',
        configs: {
          placeholder: this.props.translate('select') + this.props.translate('kpiTypeName'),
          options: [
            {
              value: '',
              label: this.props.translate('select') + this.props.translate('kpiTypeName')
            }
          ]
        }
      },
      is_active: {
        label: this.props.translate('active'),
        value: '',
        configs: {
          placeholder: this.props.translate('select') + this.props.translate('active'),
          options: [
            { value: 1, label: this.props.translate('active') },
            { value: 0, label: this.props.translate('inactive') }
          ]
        }
      }
    },
    updateProps: {
      selectedRecord: this.props.selectedRecord,
      companyOptions: this.props.companyOptions,
      filterCompany: this.props.filterCompany,
      filterKpiType: this.props.filterKpiType
    }
  }

  rowActions = [
    {
      icon: () => <Add />,
      tooltip: this.props.translate('add') + this.props.translate('kpiType'),
      onClick: () => this.openModalHandler('add'),
      isFreeAction: true,
      disabled: !this.props.pagePermission.is_add
    },
    {
      icon: () => <Edit fontSize={'small'} />,
      tooltip: this.props.translate('edit') + this.props.translate('kpiType'),
      onClick: (event, rowData) => this.openModalHandler('edit', rowData.kpi_type_id),
      disabled: !this.props.pagePermission.is_edit
    },
    {
      icon: () => <Delete fontSize={'small'} />,
      tooltip: this.props.translate('delete') + this.props.translate('kpiType'),
      onClick: (event, rowData) => this.openModalHandler('delete', rowData.kpi_type_id),
      disabled: !this.props.pagePermission.is_delete
    }
  ]

  tableStructure = [
    {
      field: 'index',
      title: '#',
      width: 70
    },
    { field: 'kpi_type_name', title: this.props.translate('kpiTypeName'), type: 'string' },
    {
      field: 'company_name',
      title: this.props.translate('companyName'),
      type: 'string',
      render: rowData => {
        return rowData.company?.company_name
      }
    },
    {
      field: 'is_active',
      title: this.props.translate('active'),
      render: rowData => {
        return <Checkbox className={classes.Checkbox} checked={!!rowData.is_active} disabled />
      },
      width: 100
    }
  ]

  componentDidMount() {
    this.props.fetchOptions()
    this.props.fetchKpiType()
  }
  componentDidUpdate(prevprops) {
    if (prevprops.success !== this.props.success && this.props.success) {
      this.clearModal()
    }
  }
  static getDerivedStateFromProps = (props, state) => {
    let updatedState = {}
    let { updateProps } = state
    const updateOptions = (stateId, propsId, attr) => {
      const inputGroups = state.inputGroups
      const targetLevelItem = inputGroups[stateId]
      let [attrId, attrName, attrPlaceHolder] = attr

      updatedState = updateObject(updatedState, {
        inputGroups: updateObject(inputGroups, {
          [stateId]: updateFormOptions(
            props[propsId],
            targetLevelItem,
            attrId,
            attrId,
            attrName,
            attrPlaceHolder
          )
        }),
        updateProps: updateObject(updateProps, { [propsId]: props[propsId] })
      })
    }
    const updateFilter = (stateId, propsId, attr) => {
      let [attrId, attrName] = attr

      updatedState = updateObject(updatedState, {
        filterControls: updateObject(state.filterControls, {
          [stateId]: updateFilterOptions(
            props[propsId],
            state.filterControls[stateId],
            attrId,
            attrId,
            attrName,
            null,
            null,
            state.filterControls[stateId].value
          )
        }),
        updateProps: updateObject(updateProps, { [propsId]: props[propsId] })
      })
    }
    if (props.companyOptions !== updateProps.companyOptions) {
      updateOptions('company_id', 'companyOptions', [
        'company_id',
        { code: 'company_code', name: 'company_name' },
        'Select Company'
      ])
      updateFilter('company_id', 'companyOptions', [
        'company_id',
        { code: 'company_code', name: 'company_name' }
      ])
    }
    if (props.filterKpiType !== updateProps.filterKpiType) {
      updateFilter('kpi_type_id', 'filterKpiType', ['kpi_type_id', 'kpi_type_name'])
    }
    if (props.selectedRecord !== updateProps.selectedRecord) {
      let newKpiTypeData = Object.entries(state.inputGroups).reduce((kpiTypeGroups, kpiType) => {
        let [kpiTypeKey, kpiTypeAttrs] = kpiType
        let value = ''
        let valid = false
        let touched = false
        let errorMessage = null
        if (!kpiTypeAttrs.validation || !kpiTypeAttrs.validation.required) {
          valid = true
        }
        if (kpiTypeAttrs.elementType === 'checkbox') {
          value = false
        } else if (kpiTypeAttrs.elementType === 'datePicker') {
          value = new Date()
        }
        if (props.selectedRecord && props.selectedRecord[kpiTypeKey]) {
          value = props.selectedRecord[kpiTypeKey]

          let { isValid, error } = checkValidity(value, kpiTypeAttrs.validation, kpiTypeAttrs.label)
          if (kpiTypeAttrs.elementType === 'newselect') {
            value = state.inputGroups[kpiTypeKey].elementConfig.options.find(
              res => res.value === value
            )
          }
          if (kpiTypeAttrs.elementType === 'checkbox') {
            value = !!value
          }
          valid = isValid
          errorMessage = error
        }

        const newKpiTypeAttrs = {
          ...kpiTypeAttrs,
          value: value,
          valid: valid,
          error: errorMessage,
          touched: touched
        }

        return updateObject(kpiTypeGroups, { [kpiTypeKey]: { ...newKpiTypeAttrs } })
      }, {})
      updatedState = updateObject(updatedState, {
        inputGroups: newKpiTypeData,
        formValid: true,
        updateProps: {
          ...updateProps,
          selectedRecord: props.selectedRecord
        }
      })
    }
    return updatedState
  }
  onPageChangeHandler = (event, page) => {
    const pageOptions = {
      page: page,
      perPage: this.props.pagination.perPage
    }
    const payload = extractFilterOptions(this.state.filterControls, pageOptions)
    this.props.fetchKpiType(payload)
  }

  onPerPageChangeHandler = perPage => {
    const pageOptions = {
      page: this.props.pagination.currentPage,
      perPage: perPage
    }
    const payload = extractFilterOptions(this.state.filterControls, pageOptions)
    this.props.fetchKpiType(payload)
  }

  searchInputChangeHandler = e => {
    const searchText = e.target.value
    this.setState({
      searchText: searchText
    })
  }
  clearInput = () => {
    let newFormData = Object.entries(this.state.inputGroups).reduce((formGroups, form) => {
      let [formKey, formAttrs] = form
      let newFormAttrs
      switch (formKey) {
        case 'is_active':
          newFormAttrs = {
            ...formAttrs,
            value: true
          }

          break
        default:
          newFormAttrs = {
            ...formAttrs,
            value: ''
          }
          break
      }

      return updateObject(formGroups, { [formKey]: { ...newFormAttrs } })
    }, {})
    this.setState({ inputGroups: newFormData })
  }
  openModalHandler = (action, recordId) => {
    if (recordId && action === 'edit') {
      this.props.fetchKpiTypeById(recordId)
    }
    this.setState({
      action: action,
      actionRecordId: recordId
    })

    if (action === 'delete') {
      this.openConfirmationModal(recordId)
    } else {
      this.props.fetchOptions()
      this.openModal()
    }
  }

  openModal = () => {
    this.setState({
      modalOpen: true
    })
  }

  closeModal = () => {
    if (this.state.action === 'edit') {
      this.clearModal()
    } else {
      this.setState({
        modalOpen: false
      })
    }
  }
  clearModal = () => {
    this.clearInput()
    this.props.clearSelectedRecord()
    if (this.state.addAno) {
      this.setState({
        actionRecordId: null,
        formValid: false,
        addAno: false
      })
    } else {
      this.setState({
        actionRecordId: null,
        formValid: false,
        modalOpen: false
      })
    }
  }

  kpiTypeSubmitHandler = type => {
    let kpiTypeData = Object.entries(this.state.inputGroups).reduce((kpiTypeData, kpiTypeEntry) => {
      let value = ''
      let [kpiTypeKey, kpiTypeAttrs] = kpiTypeEntry
      if (kpiTypeAttrs.elementType === 'newselect') {
        value = kpiTypeAttrs.value?.value
      } else {
        value = kpiTypeAttrs.value
      }
      return updateObject(kpiTypeData, { [kpiTypeKey]: value })
    }, {})

    if (this.state.action === 'add') {
      this.props.createKpiType({ ...kpiTypeData }, getPageStatus(this.props.pagination, false))
      if (type === 'saveAno') {
        this.setState({
          addAno: true
        })
      }
    } else if (this.state.action === 'edit') {
      this.props.updateKpiType(
        this.state.actionRecordId,
        { ...kpiTypeData },
        getPageStatus(this.props.pagination, false)
      )
    }
  }

  inputChangeHandler = (groupKey, kpiTypeKey, event) => {
    const inputGroup = this.state.inputGroups
    const kpiTypeItem = inputGroup[kpiTypeKey]
    let inputValue = ''

    switch (kpiTypeItem.elementType) {
      case 'textEditor':
        inputValue = event.target.getContent()
        break
      case 'newselect':
        inputValue = event
        break
      case 'checkbox':
        inputValue = !kpiTypeItem.value
        break
      case 'datePicker':
        inputValue = event
        break
      default:
        inputValue = event.target.value
        break
    }
    if (kpiTypeKey === 'appraisal_type_id') {
      this.props.fetchParentKpiTypeOptions(inputValue.value)
    }
    const { isValid, error } = checkValidity(inputValue, kpiTypeItem.validation, kpiTypeItem.label)

    const updatedKpiTypeItem = {
      ...kpiTypeItem,
      value: inputValue,
      valid: isValid,
      error: error,
      touched: true
    }
    const updateGroup = updateObject(inputGroup, { [kpiTypeKey]: updatedKpiTypeItem })
    let formIsValid = true
    Object.values(updateGroup).map(attr => {
      return (formIsValid = formIsValid && attr.valid)
    })

    this.setState({
      inputGroups: updateObject(this.state.inputGroups, { [kpiTypeKey]: updatedKpiTypeItem }),
      formValid: formIsValid
    })
  }

  closeConfirmationModal = () => {
    this.setState({
      confirmationModalOpen: false
    })
  }

  openConfirmationModal = () => {
    this.setState({
      confirmationModalOpen: true
    })
  }

  closeFilterModal = () => {
    this.setState({
      filterModalOpen: false
    })
  }

  openFilterModal = () => {
    let filterControls = this.state.filterControls

    Object.entries(filterControls).map((data, key) => {
      let [datakey] = data

      return (filterControls = updateObject(filterControls, {
        [datakey]: { ...filterControls[datakey], value: '' }
      }))
    })

    this.props.fetchFilter()

    this.setState({
      filterModalOpen: true,
      filterControls: filterControls,
      filter: []
    })
  }
  deleteRecord = () => {
    const recordId = this.state.actionRecordId

    this.props.deleteKpiType(recordId, getPageStatus(this.props.pagination, false))

    this.closeConfirmationModal()
  }

  handleFilterChange = (itemKey, e) => {
    const filterValue = e
    const filterItem = this.state.filterControls[itemKey]
    if (itemKey === 'company_id') {
      this.props.fetchKPITypeOptions({ company_id: filterValue?.value })
    }
    this.setState({
      filterControls: updateObject(this.state.filterControls, {
        [itemKey]: {
          ...filterItem,
          value: filterValue
        }
      }),
      filter: { ...this.state.filter, [itemKey]: filterValue?.value }
    })
  }

  filterRecords = () => {
    // TODO fetch data from server with seleted fliter
    let param = { ...this.state.filter, page: 1, perPage: 10 }
    this.props.fetchKpiType(param)
    this.closeFilterModal()
  }

  render() {
    let kpiTypeLabel = <Spinner />

    if (!this.props.loading) {
      kpiTypeLabel = Object.entries(this.state.inputGroups).map((item, key) => {
        return (
          <Form
            key={key}
            form={item}
            inputChanged={(kpiTypeKey, e) => this.inputChangeHandler(key, kpiTypeKey, e)}
            formValid={this.state.formIsValid}
          />
        )
      })
    }
    // const buttonGroups = (
    //   <div className={classes.ButtonGroup}>
    //     <span className={classes.Button}>
    //       <Button
    //         color={'primary'}
    //         clicked={this.kpiTypeSubmitHandler}
    //         disabled={!this.state.formValid}>
    //         {this.props.translate('save')}
    //       </Button>
    //     </span>
    //     <span className={classes.Button}>
    //       <Button color={'default'} clicked={this.clearModal}>
    //         {this.props.translate('cancel')}
    //       </Button>
    //     </span>
    //   </div>

    // )
    const footer = (
      <Footer
        save={() => this.kpiTypeSubmitHandler('save')}
        another={() => this.kpiTypeSubmitHandler('saveAno')}
        showAnother={this.state.action === 'add'}
        cancel={() => this.closeModal()}
        disable={!validateForm(this.state.inputGroups)}
      />
    )
    return (
      <Aux>
        <ConfirmationModal
          open={this.state.confirmationModalOpen}
          cancelled={this.closeConfirmationModal}
          confirmed={this.deleteRecord}
          promptText={this.props.translate('confirmDel')}
        />
        <FilterModal
          open={this.state.filterModalOpen}
          cancelled={this.closeFilterModal}
          filterSaved={this.filterRecords}
          filterChanged={(itemKey, e) => this.handleFilterChange(itemKey, e)}
          filterControls={this.state.filterControls}
        />
        <Alert />
        <Modal
          open={this.state.modalOpen}
          onHide={this.closeModal}
          header={this.props.translate(this.state.action) + this.props.translate('kpiType')}
          backdropClicked={this.closeModal}
          footer={footer}>
          <div className={classes.ModalBody}>{kpiTypeLabel}</div>
        </Modal>
        <Card>
          <CardHeader>
            <FilterBar buttonClicked={this.openFilterModal} />
          </CardHeader>
          <CardBody>
            <DataTable
              tableTitle={this.props.translate('kpiType')}
              data={this.props.data}
              structure={this.tableStructure}
              loading={this.props.loadingQueue.includes('record')}
              pagination={this.props.pagination}
              pageChange={this.onPageChangeHandler}
              perPageChange={this.onPerPageChangeHandler}
              rowActions={this.rowActions}
            />
          </CardBody>
        </Card>
      </Aux>
    )
  }
}

const mapStateToProps = state => {
  return {
    pagination: state.kpiType.pagination,
    data: state.kpiType.records,
    loading: state.kpiType.loading,
    filterLoading: state.kpiType.filterLoading,
    success: state.kpiType.success,
    selectedRecord: state.kpiType.selectedRecord,
    companyOptions: state.kpiType.company,
    filterCompany: state.kpiType.filterCompany,
    filterKpiType: state.kpiType.filterKpiType,
    loadingQueue: state.kpiType.loadingStates
  }
}

const mapDispatchToProps = dispatch => {
  return {
    fetchKpiType: filterOptions => dispatch(actions.fetchKpiType(filterOptions)),
    fetchKpiTypeById: recordId => dispatch(actions.fetchKpiTypeById(recordId)),
    clearSelectedRecord: () => dispatch(actions.clearSelectedKpiTypeRecord()),
    createKpiType: (recordData, page) => dispatch(actions.createKpiType(recordData, page)),
    updateKpiType: (recordId, recordData, page) =>
      dispatch(actions.updateKpiType(recordId, recordData, page)),
    deleteKpiType: (recordId, page) => dispatch(actions.deleteKpiType(recordId, page)),
    fetchOptions: () => {
      dispatch(actions.fetchCompanyOptions())
    },
    fetchKPITypeOptions: filter => dispatch(actions.fetchKPITypeOptions(filter)),
    fetchFilter: () => {
      dispatch(actions.fetchCompanyOptions())
      dispatch(actions.fetchKPITypeOptions())
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(withTranslate(KpiType))
